const languageOptionsList = [
  { locale: 'en', label: 'English' },
  { locale: 'ar', label: 'العربية' },
  { locale: 'pt-BR', label: 'Português (Brasil)' },
]

// 测试环境地址
const testEnvHost = ['courier.mykeeta.test.sankuai.com', 'courier-eu.sailor.test.keetapp.com']
const courierHosts = {
  test: 'courier.mykeeta.test.sankuai.com',
  st: 'courier.mykeeta.st.sankuai.com',
  prod: 'courier.mykeeta.com',
}

const HOSTENVMAP = {
  'courier.mykeeta.test.sankuai.com': 'test',
  'courier.mykeeta.st.sankuai.com': 'st',
  'courier.mykeeta.com': 'prod',
}

const AWPENVMAP = {
  newtest: 'test',
  test01: 'test',
  test02: 'test',
  staging: 'st',
  production: 'prod',
}
const testEnvSSOClientId = '24c3c79246'
const productEnvSSOClientId = '94a2e31540'
const productEnvSSOClientIdOp = '5487438b9a'

export { HOSTENVMAP, AWPENVMAP, courierHosts, testEnvHost, languageOptionsList, testEnvSSOClientId, productEnvSSOClientId, productEnvSSOClientIdOp }
